module.exports = __webpack_public_path__ + "static/img/son3.c445a2b9.png";